const THEME_KEY = 'app-theme'

const themes = [
  {
    name: '默认蓝白',
    key: 'default',
    sidebar: '#304156',
    sidebarText: '#bfcbd9',
    sidebarActive: '#409EFF',
    header: '#ffffff',
    loginBg: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    // loginBg: 'linear-gradient(135deg, #a5d6a7 0%, #ffffff 100%)'
  },
  {
    name: '深海绿',
    key: 'green',
    sidebar: '#1a3c34',
    sidebarText: '#a8d5c2',
    sidebarActive: '#42b983',
    header: '#ffffff',
    loginBg: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)'
  },
  {
    name: '暗夜黑',
    key: 'dark',
    sidebar: '#1a1a2e',
    sidebarText: '#a0a8c0',
    sidebarActive: '#e94560',
    header: '#16213e',
    loginBg: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)'
  },
  {
    name: '活力橙',
    key: 'orange',
    sidebar: '#3d1c02',
    sidebarText: '#f5c6a0',
    sidebarActive: '#ff6b35',
    header: '#ffffff',
    loginBg: 'linear-gradient(135deg, #f7971e 0%, #ffd200 100%)'
  }
]

const saved = localStorage.getItem(THEME_KEY)
const defaultTheme = themes.find(t => t.key === saved) || themes[0]

const state = {
  themes,
  current: defaultTheme,
  visitedViews: [],
}

const getters = {
  theme: state => state.themes.find(t => t.key === state.currentTheme) || state.themes[0],
  themes: state => state.themes
}
const mutations = {
  SET_THEME(state, theme) {
    state.current = theme
    localStorage.setItem(THEME_KEY, theme.key)
  },
  ADD_VISITED_VIEW: (state, view) => {
    // 如果已经存在或者没有 title（非菜单页面），则不添加
    if (state.visitedViews.some(v => v.path === view.path)) return
    state.visitedViews.push({
      name: view.name,
      path: view.path,
      title: view.meta.title || '未知页面'
    })
  },
  DEL_VISITED_VIEW: (state, path) => {
    state.visitedViews = state.visitedViews.filter(v => v.path !== path)
  },
  DEL_OTHERS_VIEWS: (state, path) => {
    state.visitedViews = state.visitedViews.filter(v => v.path === path || v.path === '/index')
  },
  DEL_ALL_VIEWS: (state) => {
    // 过滤掉首页，只保留首页
    state.visitedViews = state.visitedViews.filter(v => v.path === '/index')
  }
}

const actions = {
  setTheme({ commit }, theme) {
    commit('SET_THEME', theme)
  },
  addView({ commit }, view) {
    commit('ADD_VISITED_VIEW', view)
  },
  delView({ commit }, path) {
    commit('DEL_VISITED_VIEW', path)
  }
}

export default { namespaced: true, state, mutations, actions }